import React, { useState, useRef, useContext } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import CustomDropdown from '../../../../custom/customDropdown';
import { AuthContext } from '../../../../Header/auth - context';
import { useSelector } from 'react-redux';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
const daniNedelje = [
    { value: 1, label: 'Ponedeljak' },
    { value: 2, label: 'Utorak' },
    { value: 3, label: 'Sreda' },
    { value: 4, label: 'Četvrtak' },
    { value: 5, label: 'Petak' },
    { value: 6, label: 'Subota' },
    { value: 7, label: 'Nedelja' },
];

const rezimiObracuna = [
    { value: 1, label: 'Automatski' },
    { value: 0, label: 'Manuelni' },
];

const emptyForm = {
    Rezim: 1,
    Naziv: '',
    TipVozaca: null,
    VrstaVozila: null,
    Kombi: false,
    ZamenskiVozac: false,
    DanOd: null,
    DanDo: null,
    ADR: null,
    Iznos: null,
    Valuta: null,
    Vreme: null,
    VazenjeOd: null,
    VazenjeDo: null,
    Napomena: '',
    ID_Drzava: null,
};

const BonusiTab = ({ options, bonusiDB, onRefresh, toast }) => {
  const { t } = useTranslation();
    const auth = useContext(AuthContext);
    const company = useSelector(state => state.company);
    const formRef = useRef(null);
    const [formData, setFormData] = useState(emptyForm);
    const [selectedId, setSelectedId] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);

    const resetForm = () => { setFormData(emptyForm); setSelectedId(null); setFormSubmitted(false); };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'Naziv') {
                updated.ADR = /adr/i.test(value) ? true : null;
            }
            return updated;
        });
    };

    const handleTipBonusaChange = (e) => {
        const val = e.target.value;
        const opt = (options.TipoviVozacaDB || []).find(o => o.value === val);
        setFormData(prev => ({
            ...prev,
            TipVozaca:     val,
            VrstaVozila:   opt?.VrstaVozila  ?? null,
            Kombi:       opt?.Kombi  != null ? !!opt.Kombi  : false,
            ZamenskiVozac: opt?.ZamenskiVozac != null ? !!opt.ZamenskiVozac : false,
            ADR:         /adr/i.test(prev.Naziv) ? true : null,
        }));
    };

    const handleRowSelect = (row) => {
        const id = row?.id;
        setSelectedId(prev => {
            const next = String(prev) === String(id) ? null : id;
            if (next !== null) {
                setFormData({
                    Rezim: row.Rezim != null ? (row.Rezim ? 1 : 0) : 1,
                    Naziv: row.Naziv || '',
                    TipVozaca: row.TipVozaca || null,
                    VrstaVozila: row.VrstaVozila || null,
                    Kombi: !!row.Kombi,
                    ZamenskiVozac: !!row.ZamenskiVozac,
                    DanOd: row.DanOd != null ? Number(row.DanOd) : null,
                    DanDo: row.DanDo != null ? Number(row.DanDo) : null,
                    ADR: row.ADR != null ? !!row.ADR : null,
                    Iznos: row.Iznos != null ? Number(row.Iznos) : null,
                    Valuta: row.Valuta || null,
                    Vreme: row.Vreme ? new Date('1970-01-01T' + row.Vreme) : null,
                    VazenjeOd: parseDateStr(row.VazenjeOd),
                    VazenjeDo: parseDateStr(row.VazenjeDo),
                    Napomena: row.Napomena || '',
                    ID_Drzava: row.ID_Drzava || null,
                });
            } else {
                setFormData(emptyForm);
                setFormSubmitted(false);
            }
            return next;
        });
    };

    const parseDateStr = (str) => {
        if (!str) return null;
        const parts = str.replace(/\./g, ' ').trim().split(/\s+/);
        if (parts.length < 3) return null;
        const d = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
        return isNaN(d.getTime()) ? null : d;
    };

    const toUtcIso = (d) => {
        if (!d) return null;
        const x = d instanceof Date ? d : new Date(d);
        const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
        return utc.toISOString().slice(0, 19) + 'Z';
    };

    const toTimeStr = (d) => {
        if (!d) return null;
        const x = d instanceof Date ? d : new Date(d);
        return x.toTimeString().slice(0, 8);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        if (formRef.current && !formRef.current.checkValidity()) { formRef.current.reportValidity(); return; }
        confirmDialog({
            message: selectedId ? 'Sačuvati izmene bonusa?' : 'Dodati novi bonus?',
            acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: () => doSave(),
        });
    };

    const doSave = () => {
        const payload = {
            ...formData,
            Kombi: formData.Kombi ? 1 : 0,
            ZamenskiVozac: formData.ZamenskiVozac ? 1 : 0,
            ADR: formData.ADR === null ? null : (formData.ADR ? 1 : 0),
            Vreme: toTimeStr(formData.Vreme),
            VazenjeOd: toUtcIso(formData.VazenjeOd),
            VazenjeDo: toUtcIso(formData.VazenjeDo),
        };
        fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageObracunSifarnik', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ step: 'SAVE_BONUS', id: selectedId || 0, formData: payload }),
        })
            .then(r => r.json())
            .then(data => {
                const msg = data[0]?.message || '';
                if (msg.includes('Nema izmena')) {
                    toast.current.show({ severity: 'warn', summary: msg, life: 3000 });
                    return;
                }
                toast.current.show({ severity: 'success', summary: msg || 'Uspešno!', life: 3000 });
                resetForm();
                onRefresh();
            })
            .catch(() => toast.current.show({ severity: 'error', summary: t('admin.m_greska_pri_cuvanju_bonusa'), life: 3000 }));
    };

    const handleDelete = () => {
        if (!selectedId) { toast.current.show({ severity: 'warn', summary: t('admin.m_izaberite_bonus_za_brisanje'), life: 3000 }); return; }
        confirmDialog({
            message: 'Obrisati izabrani bonus?',
            acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: () => {
                fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageObracunSifarnik', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
                    body: JSON.stringify({ step: 'DELETE_BONUS', id: selectedId }),
                })
                    .then(r => r.json())
                    .then(() => { toast.current.show({ severity: 'success', summary: t('admin.m_bonus_obrisan'), life: 3000 }); resetForm(); onRefresh(); })
                    .catch(() => toast.current.show({ severity: 'error', summary: t('admin.m_greska_pri_brisanju'), life: 3000 }));
            },
        });
    };

    const invalid = (val) => formSubmitted && (val === null || val === '' || val === undefined);

    const exportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Bonusi');
        const headers = ['Režim', 'Naziv', 'Vrsta vozila', 'Dan od', 'Dan do', 'Vreme', 'Iznos', 'Zamenski vozač', 'Država', 'Važi od', 'Važi do', 'Napomena'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } };
            cell.border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
        });
        (bonusiDB || []).forEach(r => {
            const row = worksheet.addRow([
                (r.Rezim != null && !r.Rezim) ? 'Manuelni' : 'Automatski',
                r.Naziv || '',
                r.VrstaVozilaNaziv || (r.ZamenskiVozac ? 'Svi tipovi' : ''),
                r.DanOd != null ? (daniNedelje.find(d => d.value === r.DanOd)?.label || r.DanOd) : '',
                r.DanDo != null ? (daniNedelje.find(d => d.value === r.DanDo)?.label || r.DanDo) : '',
                r.Vreme ? r.Vreme.slice(0, 5) : '',
                r.Iznos != null ? `${Number(r.Iznos).toFixed(2)} ${r.ValutaNaziv || ''}` : '',
                r.ZamenskiVozac ? 'Da' : 'Ne',
                r.DrzavaNaziv || '',
                r.VazenjeOd || '',
                r.VazenjeDo || '',
                r.Napomena || '',
            ]);
            row.eachCell(cell => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });
        });
        worksheet.columns.forEach(col => {
            let max = 10;
            col.eachCell(cell => { if (cell.value) max = Math.max(max, cell.value.toString().length); });
            col.width = max + 2;
        });
        const dt = new Date().toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Belgrade' }).replace(/,/g, '');
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Bonusi - ${company?.companyName || ''} - ${dt}.xlsx`);
    };

    const tableHeader = (
        <div className="export-buttons fakture-stavke-header">
            <Tooltip target=".export-buttons>button" position="bottom" />
            <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                {selectedId && <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDelete} data-pr-tooltip={t('common.delete')} />}
            </div>
            <input type="search" placeholder={t('common.search')} className="p-inputtext p-component"
                onInput={e => setGlobalFilter(e.target.value)} />
        </div>
    );

    return (
        <div style={{ marginTop: '1%' }}>
            <Tooltip target=".field-tooltip" position="top" />
            <ConfirmDialog />
            <div className="blagajnaDashboard dnevniceDashboard">
                <Card>
                    <form autoComplete="off" ref={formRef}>
                        <div className="gridLicni">
                            <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>Režim obračuna: <i className="pi pi-info-circle field-tooltip" data-pr-tooltip="Automatski = procedura ga koristi pri autoobračunu bonusa (Dodatni obračun)" style={{ marginLeft: '3px', color: '#888', cursor: 'pointer' }} /></label>
                                <CustomDropdown name="Rezim" value={formData.Rezim}
                                    options={rezimiObracuna} optionLabel="label" placeholder={t('admin.phRezim')}
                                    required invalid={invalid(formData.Rezim)} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('admin.naziv')}:</label>
                                <InputText name="Naziv" value={formData.Naziv} onChange={handleChange}
                                    required className={invalid(formData.Naziv) ? 'p-invalid' : ''} />
                            </div>
                            <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('admin.tipBonusa')}:</label>
                                <CustomDropdown name="TipVozaca" value={formData.TipVozaca}
                                    options={(options.TipoviVozacaDB || []).filter(o => o.value !== 'ADR')} optionLabel="label" placeholder={t('magacin.phTip')}
                                    required invalid={invalid(formData.TipVozaca)} onChange={handleTipBonusaChange} showClear />
                            </div>
                            <div className="col-12 md:col-3" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>Dan od: <i className="pi pi-info-circle field-tooltip" data-pr-tooltip="Prazan = važi za sve dane" style={{ marginLeft: '3px', color: '#888', cursor: 'pointer' }} /></label>
                                <CustomDropdown name="DanOd" value={formData.DanOd}
                                    options={daniNedelje} optionLabel="label" placeholder={t('admin.danOd')}
                                    onChange={handleChange} showClear />
                            </div>
                            <div className="col-12 md:col-3" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('admin.danDo')}:</label>
                                <CustomDropdown name="DanDo" value={formData.DanDo}
                                    options={daniNedelje} optionLabel="label" placeholder={t('admin.danDo')}
                                    onChange={handleChange} showClear />
                            </div>
                            <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('admin.vremeUslov')}:</label>
                                <Calendar name="Vreme" value={formData.Vreme}
                                    onChange={handleChange} timeOnly showIcon
                                    placeholder={t('admin.phVreme')} />
                            </div>
                            <div className="col-12 md:col-3" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('nova.iznos')}:</label>
                                <InputNumber name="Iznos" value={formData.Iznos}
                                    onValueChange={handleChange} minFractionDigits={2} maxFractionDigits={2}
                                    required className={invalid(formData.Iznos) ? 'p-invalid' : ''} />
                            </div>
                            <div className="col-12 md:col-3" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('nova.valuta')}:</label>
                                <CustomDropdown name="Valuta" value={formData.Valuta}
                                    options={options.ValuteDB} optionLabel="label" placeholder={t('nova.valuta')}
                                    required invalid={invalid(formData.Valuta)} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label>{t('ture.vaziOd')}:</label>
                                <Calendar name="VazenjeOd" value={formData.VazenjeOd} onChange={handleChange}
                                    showIcon dateFormat="dd.mm.yy" mask="99.99.9999"
                                    required className={invalid(formData.VazenjeOd) ? 'p-invalid' : ''} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label>{t('ture.vaziDo')}:</label>
                                <Calendar name="VazenjeDo" value={formData.VazenjeDo} onChange={handleChange}
                                    showIcon dateFormat="dd.mm.yy" mask="99.99.9999"
                                    required className={invalid(formData.VazenjeDo) ? 'p-invalid' : ''} />
                            </div>
                            <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>Država: <i className="pi pi-info-circle field-tooltip" data-pr-tooltip="Prazan = važi za sve države" style={{ marginLeft: '3px', color: '#888', cursor: 'pointer' }} /></label>
                                <CustomDropdown name="ID_Drzava" value={formData.ID_Drzava}
                                    options={options.DrzaveDB} optionLabel="label" placeholder={t('admin.sveDrzave')}
                                    onChange={handleChange} showClear />
                            </div>
                            <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{t('nova.napomena')}:</label>
                                <InputText name="Napomena" value={formData.Napomena} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleSave} style={{ minWidth: 'fit-content', marginTop: '2%' }} className="btn btn-success">
                                {selectedId ? 'SAČUVAJ' : 'UNOS'}
                            </button>
                        </div>
                    </form>
                </Card>
                <Card>
                    <DataTable className="stavke-tabela" value={bonusiDB || []} paginator rows={10} scrollable scrollHeight="45vh"
                        header={tableHeader} emptyMessage="Nema bonusa" resizableColumns
                        globalFilter={globalFilter}
                        rowClassName={row => String(row.id) === String(selectedId) ? 'selected-row' : ''}>
                        <Column header={t('common.choose')} style={{ minWidth: '90px' }}
                            body={rowData => (
                                <Button label={t('common.choose')} icon="pi pi-eye" type="button"
                                    className="p-button-text p-button-sm" onClick={() => handleRowSelect(rowData)} />
                            )} />
                        <Column field="Rezim" header={t('admin.rezim')} sortable style={{ minWidth: '110px' }}
                            body={r => (r.Rezim != null && !r.Rezim) ? 'Manuelni' : 'Automatski'} />
                        <Column field="Naziv" header={t('admin.naziv')} sortable style={{ minWidth: '150px' }} />
                        <Column field="TipVozaca" header={t('admin.tipBonusa')} sortable style={{ minWidth: '150px' }}
                            body={r => {
                                const opt = (options.TipoviVozacaDB || []).find(o => o.value === r.TipVozaca);
                                return opt?.label || r.TipVozaca || '-';
                            }} />
                        <Column field="DanOd" header={t('admin.danOd')} style={{ minWidth: '110px' }}
                            body={r => r.DanOd != null ? (daniNedelje.find(d => d.value === r.DanOd)?.label || r.DanOd) : '-'} />
                        <Column field="DanDo" header={t('admin.danDo')} style={{ minWidth: '110px' }}
                            body={r => r.DanDo != null ? (daniNedelje.find(d => d.value === r.DanDo)?.label || r.DanDo) : '-'} />
                        <Column field="Vreme" header={t('admin.vreme')} sortable style={{ minWidth: '90px' }}
                            body={r => r.Vreme ? r.Vreme.slice(0, 5) : '-'} />
                        <Column field="Iznos" header={t('nova.iznos')} sortable style={{ minWidth: '100px' }}
                            body={r => r.Iznos != null ? `${Number(r.Iznos).toFixed(2)} ${r.ValutaNaziv || ''}` : '-'} />
                        <Column field="DrzavaNaziv" header={t('ture.drzava')} style={{ minWidth: '120px' }} body={r => r.DrzavaNaziv || '-'} />
                        <Column field="VazenjeOd" header={t('ture.vaziOd')} sortable style={{ minWidth: '110px' }} />
                        <Column field="VazenjeDo" header={t('ture.vaziDo')} sortable style={{ minWidth: '110px' }} />
                        <Column field="Napomena" header={t('nova.napomena')} style={{ minWidth: '150px' }} />
                    </DataTable>
                </Card>
            </div>
        </div>
    );
};

export default BonusiTab;
